import React, { PureComponent } from 'react';

export default class ImagePreloader extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            imageLoaded: false,
        };
    }

    componentWillMount() {
        if (typeof window !== 'undefined') {
            const image = new Image();
            image.src = this.props.imageUrl;
            const { complete: imageLoaded } = image;

            this.setState(() => ({ imageLoaded }));
            if (!imageLoaded) {
                image.onload = () => {
                    this.setState(() => ({ imageLoaded: true }));
                };
            }
        }
    }

    render() {
        return (
            <div
                css={{
                    opacity: this.state.imageLoaded ? 1 : 0,
                    transition: '0.3s opacity',
                    ...this.props.style,
                }}
            >
                {this.props.children}
            </div>
        );
    }
}
